import { withGlobal } from "components/global/GlobalWrapper";
import { InvoicePayment } from "./InvoicePayment";
import { residentPaymentsReducers } from "components/stores/resident_payments/reducers";

export default withGlobal(InvoicePayment, { reducers: residentPaymentsReducers })
